<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import type ExemplarList from '../../exemplar-list';
    import {exists} from 'shared/utils/custom-utils';
    import {getPageContext} from 'shared/layouts/page-context';
    import {onDestroy} from 'svelte';
    import KpDocumentDetailTabset from '../../kp-document-detail-tabset/KpDocumentDetailTabset.svelte';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();

    const model = pageContext.staticData.model;
    let exemplarList: ExemplarList | undefined;
    const reactiveDataUnsubscribe = pageContext.reactiveData.subscribe((data) => exemplarList = data.exemplarList);
    onDestroy(reactiveDataUnsubscribe);
</script>

{#if exists(exemplarList)}
    <KpDocumentDetailTabset record={model.record}
                            exemplarList={exemplarList}
                            citationStyles={model.citationStyles}
                            detailTableRows={model.record.detailTableRows}
                            exemplarColumns={model.exemplarsView.exemplarColumns}
                            marcFields={model.fields}
                            tabsConfiguration={model.documentTabsConfiguration}
                            exemplarTabsByBuildingsEnabled={model.exemplarTabsByBuildingsEnabled}
                            showInformationTab={model.showRecordInformationTab}/>
{/if}